import {SET_BOTH_CALENDAR, SET_PRICE_SUBSCRIBER, SET_PRICE_TYPE, UPDATE_PRICE_SUBSCRIBER} from "./constans";

let initialState = {

};
let newState = null;
const subscriberCalendarReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_PRICE_SUBSCRIBER:
            return action.payload
        case SET_PRICE_TYPE:
            return {...state, [action.room]: {...state[action.room], priceType: action.priceType}}
        case UPDATE_PRICE_SUBSCRIBER:
            return {...state, ...action.payload}
        case SET_BOTH_CALENDAR: {
            return {}
        }
        default:
            return state;
    }
};


export default subscriberCalendarReducers;